import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
export const CardTitle = ({ title, icon, size = "medium", }) => (_jsxs(Box, { id: title.toLowerCase(), sx: {
        display: "flex",
        alignItems: "center",
        px: 2,
        py: 1,
        svg: { mr: 0.5 },
    }, children: [icon, _jsx(Typography, { variant: size === "small" ? "h5" : "h3", children: title })] }));
//# sourceMappingURL=CardTitle.js.map